import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.css'],
})
export class ConfirmDialogComponent implements OnInit {
  message: string;

  body: string;

  constructor(
    public dialogRef: MatDialogRef<ConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      message: string;
      body?: string;
    },
  ) {}

  ngOnInit(): void {
    this.message = this.data.message;
    this.body = this.data.body;
  }

  onCancel(): void {
    this.dialogRef.close({
      confirmed: false,
    });
  }

  onConfirm(): void {
    this.dialogRef.close({
      confirmed: true,
    });
  }
}
